module.exports = __webpack_public_path__ + "99c951e27553e37a81bac872da5ace54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/leto-15.jpg
// module id = 1155
// module chunks = 0